import { render, staticRenderFns } from "./inTagInfor.vue?vue&type=template&id=2e0c2f04&scoped=true"
import script from "./inTagInfor.vue?vue&type=script&lang=js"
export * from "./inTagInfor.vue?vue&type=script&lang=js"
import style0 from "./inTagInfor.vue?vue&type=style&index=0&id=2e0c2f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0c2f04",
  null
  
)

export default component.exports